import * as Headless from '@headlessui/react';
import cn from '@/utils/cn';

type TProps = { className?: string } & Omit<
  Headless.FieldProps,
  'as' | 'className'
>;

export const Field = ({ className, ...props }: TProps) => {
  return (
    <Headless.Field
      {...props}
      className={cn(
        '[&>[data-slot=label]+[data-slot=control]]:mt-2',
        '[&>[data-slot=label]+[data-slot=description]]:mt-1',
        '[&>[data-slot=description]+[data-slot=control]]:mt-2',
        '[&>[data-slot=control]+[data-slot=description]]:mt-2',
        '[&>[data-slot=control]+[data-slot=error]]:mt-2',
        className
      )}
    />
  );
};
